import PropTypes from "prop-types"

const OrganizationShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string,
  domain: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  phoneNumber: PropTypes.string,
  domainStatus: PropTypes.string,
  controllerId: PropTypes.string,
  isEmailVerified: PropTypes.bool,
  domainRecordJson: PropTypes.string,
  certificateRecordJson: PropTypes.string,
  parentOrganizationId: PropTypes.string,
})

export default OrganizationShape

